import { speakText } from "../../utils/audioHelpers";

function SpeakerIcon({ size }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
            <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
        </svg>
    );
}

// rate is optional so existing callers keep speakText's default pace.
function SpeakerButton({ text, lang = "de-DE", size = 22, label = "Play pronunciation", className = "", rate }) {
    const btnClass = className ? `speaker-btn ${className}` : "speaker-btn";
    return (
        <button type="button" className={btnClass} aria-label={label} title={label} onClick={(e) => { e.stopPropagation(); speakText(text, lang, rate ? { rate } : {}); }}>
            <SpeakerIcon size={size} />
        </button>
    );
}

export default SpeakerButton;
